import UserProgressBar from './UserProgressBar'

export default UserProgressBar
